import { render, staticRenderFns } from "./FourthForm.vue?vue&type=template&id=2cb363c2&scoped=true&"
import script from "./FourthForm.vue?vue&type=script&lang=js&"
export * from "./FourthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb363c2",
  null
  
)

export default component.exports